import type { SummaryRecord } from "../types/analyzer";
import { getScoreBackgroundColor, getScoreColor } from "../utils/scores";

interface CategorySummaryProps {
	categories: SummaryRecord;
}

const anchorMap = {
	Performance: "performance",
	Accessibility: "accessibility",
	"Best Practices": "best-practices",
	SEO: "seo",
	PWA: "pwa",
} as const;

function CategorySummary({ categories }: CategorySummaryProps) {
	const orderedCategories = {
		Performance: categories.scores.performance,
		Accessibility: categories.scores.accessibility,
		"Best Practices": categories.scores.bestPractices,
		SEO: categories.scores.seo,
		PWA: categories.scores.pwa,
	};

	return (
		<div className="summary-grid">
			{(Object.keys(orderedCategories) as Array<keyof typeof orderedCategories>).map((key) => (
				<a key={key} href={`#${anchorMap[key]}`} className="summary-card">
					<span className="summary-card__label">{key}</span>
					<span
						className="summary-card__score"
						style={{
							color: getScoreColor(orderedCategories[key]),
						}}
					>
						{Math.round(orderedCategories[key] * 100)}
					</span>
					<span
						className="summary-card__dot"
						style={{
							background: getScoreBackgroundColor(orderedCategories[key]),
							borderColor: getScoreColor(orderedCategories[key]),
						}}
					/>
					<span className="summary-card__hint">Objetivo ≥ 90</span>
				</a>
			))}
		</div>
	);
}

export default CategorySummary;
